import { Box, Button, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import { CreateItemWithDetailDto } from "lib/features/item/types";
import itemTypeValidation from "./ItemType.schema";

interface ItemTypeProps {
  initialValues: CreateItemWithDetailDto;
  onSubmit: (values: CreateItemWithDetailDto) => void;
}

const ItemType = ({ initialValues, onSubmit }: ItemTypeProps) => {
  const bookingChoices = [
    {
      id: 1,
      value: 1,
      name: "Instant Booking",
      desc: "Referees will only be able to book the date and times you set.",
    },
    {
      id: 2,
      value: 3,
      name: "Request to Book",
      desc: "A customer or Referee must first request a booking link before purchase.",
    },
  ];

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={itemTypeValidation}
      onSubmit={(values) => onSubmit(values)}
    >
      {({ values, setFieldValue, errors, touched }) => (
        <Form>
          <Box>
            <Typography
              sx={{ fontSize: "14px", fontWeight: "400", color: "#595959" }}
            >
              Select your preferred availability type for your item*
            </Typography>

            {bookingChoices.map((item) => (
              <Box
                key={item.id}
                sx={{
                  padding: "16px",
                  backgroundColor:
                    values.item_type === item.value ? "#d0eed5a5" : "#FFF",
                  flexDirection: "row",
                  alignItems: "center",
                  borderRadius: "8px",
                  border: "1px solid black",
                  marginTop: "16px",
                  cursor: "pointer",
                }}
                onClick={() => setFieldValue("item_type", item.value)}
              >
                <Typography
                  sx={{ fontSize: "20px", fontWeight: "600", color: "#000" }}
                >
                  {item.name}
                </Typography>
                <Typography
                  sx={{
                    marginTop: "5px",
                    fontSize: "14px",
                    fontWeight: "400",
                    color: "#595959",
                  }}
                >
                  {item.desc}
                </Typography>
              </Box>
            ))}

            {/* Show Validation Error */}
            {errors.item_type && touched.item_type && (
              <Typography
                color="red"
                fontSize="12px"
                sx={{ marginTop: "10px" }}
              >
                {errors.item_type}
              </Typography>
            )}

            <Button
              type="submit"
              variant="contained"
              sx={{ width: "100%", marginTop: "20px", paddingY: "10px" }}
            >
              Continue
            </Button>
          </Box>
        </Form>
      )}
    </Formik>
  );
};

export default ItemType;
